var _path, _path2, _line, _line2, _line3, _line4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNearLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2661 13.7046C22.2661 17.807 18.7686 21.2095 14.3572 21.2095C9.94588 21.2095 6.44838 17.807 6.44838 13.7046C6.44838 9.60218 9.94588 6.19972 14.3572 6.19972C18.7686 6.19972 22.2661 9.60218 22.2661 13.7046Z",
    stroke: "#47FFBD",
    strokeWidth: 1.95779
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4802 13.7045C17.4802 15.284 16.1253 16.6412 14.357 16.6412C12.5888 16.6412 11.2339 15.284 11.2339 13.7045C11.2339 12.1251 12.5888 10.7678 14.357 10.7678C16.1253 10.7678 17.4802 12.1251 17.4802 13.7045Z",
    stroke: "#47FFBD",
    strokeWidth: 1.95779
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14.062,
    y1: 5.87341,
    x2: 14.062,
    y2: 0.0000366756,
    stroke: "#47FFBD",
    strokeWidth: 1.95779
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 22.5614,
    y1: 13.3783,
    x2: 28.7145,
    y2: 13.3783,
    stroke: "#47FFBD",
    strokeWidth: 1.95779
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 14.062,
    y1: 27.4091,
    x2: 14.062,
    y2: 21.5357,
    stroke: "#47FFBD",
    strokeWidth: 1.95779
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 8.55778e-8,
    y1: 13.3783,
    x2: 6.15306,
    y2: 13.3783,
    stroke: "#47FFBD",
    strokeWidth: 1.95779
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearLocation);
export default __webpack_public_path__ + "static/media/near-location.d84643af91e76d6ec931f09f1f3b95e8.svg";
export { ForwardRef as ReactComponent };